import React from "react";
import * as SC from "../style/skill-webbutveckling-style";
import starSkill from "../../assets/at-details/starSkill.svg";

const skillLinks = {
  seo: { to: "/webbutveckling/seo-info", title: "SEO" },
  cms: { to: "/webbutveckling/cms-info", title: "CMS" },
  uxui: { to: "/webbutveckling/uxui-info", title: "UX/UI" },
  hosting: { to: "/webbutveckling/hosting-info", title: "Hosting & Förvaltning" },
};

export const AndtechWebSkills: React.FC = () => {

  return (
    <SC.SkillDetailsWeb>
        <SC.SkillIconWeb
          src={starSkill}
          aria-hidden="true"/>


      <SC.SkillsListWeb>
        {Object.entries(skillLinks).map(([key, skill]) => (
          <SC.SkillItemWeb>
            <SC.SkillWebLink key={key} to={skill.to}>
              {skill.title}
            </SC.SkillWebLink>
          </SC.SkillItemWeb>
        ))}
      </SC.SkillsListWeb>
    </SC.SkillDetailsWeb>
  );
};